import React from 'react'
import '../styles/heroSection.css';
import { InView } from 'react-intersection-observer';

const Herosection = () => {
  return (
    <div>
        <section
        className="heros-section-custom"
        role="banner"
        aria-labelledby="heros-title"
      >
        <div className="heros-custom-content-container">
          <InView triggerOnce={true} threshold={0.1}>
            {({ inView, ref }) => (
              <header
                ref={ref}
                className={`heros-custom-content ${
                  inView ? "animate" : ""
                }`}
              >
                <h1 id="heros-title">Microsoft 365 Copilot</h1>
              </header>
            )}
          </InView>
        </div>
      </section>
    </div>
  )
}

export default Herosection